
<template>
  <v-container>
    <v-data-table v-if="all_users" mobile-breakpoint="900" :items="all_users" :headers="user_list_header" :loading="loading" :search="search">
      <template v-slot:top>
        <v-row align="center" justify="space-between" class="px-3">
          <v-col cols="12" md="6">
            <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Encontrar"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-center">
            <create-user-dialog></create-user-dialog>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.actions="{ item }">
        <div v-if="item.id">
          <v-btn @click="openEditDialog(item)" color="primary" dark small icon><v-icon>mdi-pencil</v-icon></v-btn>
          <v-btn @click="deleteUser(item)" color="error" dark small icon><v-icon>mdi-delete</v-icon></v-btn>
        </div>
      </template>
      <template v-slot:no-data>
        Não há dados
      </template>
    </v-data-table>

    <edit-user-dialog v-if="edit_dialog" :user="edit_user" :dialog="edit_dialog" @closeEditDialog="handleCloseEditDialog"></edit-user-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'UserList',
  components: {
    CreateUserDialog: () => import('../create/CreateUserDialog.vue'),
    EditUserDialog: () => import('../edit/EditUserDialog.vue')
  },
  data() {
    return {
      search: '',
      edit_dialog: false,
      edit_user: null,
      user: {},
      user_list_header : [
        { text: 'id', value: 'id' },
        { text: 'Nome', value: 'name' },
        { text: 'Função', value: 'role.translated' },
        { text: 'Departamento', value: 'main_dept_name' },
        { text: 'Ações', value: 'actions' },
      ],
      loading: false
    }
  },
  mounted () {
    this.getUsers();
  },
  methods: {
    deleteUser(user) {
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        title: 'Deseja excluir usuário?',
        icon: 'question'
      }).then(r => {
        if (r.isConfirmed) {
          this.deleteOneUser(user);
        }
      })
    },
    handleCloseEditDialog() {
      this.edit_user = null;
      this.edit_dialog = false;
    },
    openEditDialog(item) {
      this.edit_user = {...item};
      this.edit_dialog = true
      console.log(this.edit_user);
      console.log(this.edit_dialog)
    },
    async getUsers() {
      this.loading = true;
      await this.indexUsers();
      this.loading = false;
    },
    ...mapActions({
      indexUsers: 'User/index',
      deleteOneUser: 'User/delete'
    })
  },
  computed: {
    ...mapState({
      all_users: state => state.User.all_users
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>